const envParser = require('./envParser');

const env = envParser.parse();

module.exports = env;
